<template>
  <router-link
    :to="'/dashboard/crops/' + data.id"
    class="crop-bar-item"
  >
    <div ref="wrapper" class="wrapper --selector-overlay-pointer">
      <div class="title">
        <!-- TODO проверить перевод -->
        <template v-if="data.owner == 0 && $ml.get(data.name)">{{ $ml.get(data.name) }}</template>
        <template v-else>{{ data.name }}</template>
        <!-- {{ data.name }} -->
      </div>
      <div class="type">
        <template v-if="data.owner == 0">{{ $ml.get(`SYSTEM`) }}</template>
        <template v-else>{{ $ml.get(`USER-DEFINED`) }}</template>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    data: {},
  },
  methods: {
    onClick(e) {

    }
  }
}
</script>

<style lang="scss" scoped>

.crop-bar-item {
  display: flex;
  flex-direction: column;
  padding: 5px 0;

  &.router-link-active {
    .title {
      color: #fff;
    }

    .type {
      color: #fff;
    }
  }

  .wrapper {
    padding: 8px 20px;
  }

  .title {
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 5px;

    transition: color 0.5s ease;
  }

  .type {
    color: #8B8D91;
    font-weight: bold;
    font-size: 10px;
    letter-spacing: 0.05em;
    margin-top: -3px;
    transition: color 0.5s ease;
  }
}

</style>
